import React from "react";

import cx from "classnames";
import moment, { type MomentInput } from "moment";

import { formatDatetime, setDatetimeTooltip } from "~/lib/utils";
import { Tooltip } from "~/ui";

type DateProps = React.HTMLAttributes<HTMLElement> & {
	as: string | React.ComponentType<React.HTMLAttributes<HTMLElement>>;
	date: MomentInput;
	inverted?: boolean;
	position?: string;
	usePopup?: boolean;
	format?: string;
	useNumbers?: boolean;
};

export default class DateComponent extends React.Component<DateProps> {
	static defaultProps = {
		as: "span",
		date: null,
	};

	render() {
		const { as: Wrapper, usePopup, date, className, children, format, useNumbers, ...extraProps } = this.props;
		const { inverted, position } = this.props;

		const givenDate = date ? date : (children as MomentInput);
		const wrapperProps = {
			...(usePopup ? null : setDatetimeTooltip(givenDate, position, inverted)),
			...extraProps,
			className: cx("date", className),
		};

		const trigger = (
			<Wrapper {...wrapperProps}>
				{format
					? moment(givenDate).format(format)
					: moment(givenDate)
							.fromNow()
							.replace(/^a\s/, useNumbers ? "1 " : "a ")}
			</Wrapper>
		);

		if (usePopup) {
			return (
				<Tooltip content={formatDatetime(givenDate)} placement="bottom">
					{trigger}
				</Tooltip>
			);
		}
		return trigger;
	}
}
